// extracted by mini-css-extract-plugin
module.exports = {"layout":"Layout_post-module--layout--3MjMN"};